/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";

/**
 *
 */
export class PreviewAccessApi extends runtime.BaseAPI {
  /**
   * Grant 30-day preview-environment access for the calling engineer. Returns 204 No Content with a \\`Set-Cookie: amy-preview-access=...\\` header scoped to \\`.freightsimple.com\\`. The hubble client doesn\'t need to read the cookie value --- the browser auto-attaches it to subsequent \\`.amy.freightsimple.com\\` requests. 403 if the caller is not on the engineering allow-list.
   * Grant 30-day preview-environment access for the calling engineer.
   */
  async grantRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/preview-access/grant`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Grant 30-day preview-environment access for the calling engineer. Returns 204 No Content with a \\`Set-Cookie: amy-preview-access=...\\` header scoped to \\`.freightsimple.com\\`. The hubble client doesn\'t need to read the cookie value --- the browser auto-attaches it to subsequent \\`.amy.freightsimple.com\\` requests. 403 if the caller is not on the engineering allow-list.
   * Grant 30-day preview-environment access for the calling engineer.
   */
  async grant(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.grantRaw(initOverrides);
    return await response.value();
  }
}
